import { TranslatableText } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { EmergencyNotificationAlert, EmergencyNotificationVariant } from './types';

type EmergencyNotificationAlertModalConfig = {
   title: TranslatableText;
   description: TranslatableText;
   variant: EmergencyNotificationVariant;
};

export const getEmergencyNotificationAlertModalConfig = (
   emergencyNotifications: EmergencyNotificationAlert[]
): EmergencyNotificationAlertModalConfig => {
   const counter = emergencyNotifications.reduce(
      (result, emergencyNotification) => {
         if (emergencyNotification.dismissed) {
            result.dismissed += 1;
         } else if (emergencyNotification.testAlarm) {
            result.testAlerts += 1;
         } else {
            result.alerts += 1;
         }
         return result;
      },
      { alerts: 0, testAlerts: 0, dismissed: 0 }
   );

   if (counter.alerts) {
      return {
         title: translationKeys.sosAlarm,
         description: translationKeys.sosAlarmHasBeenCalled,
         variant: 'error',
      };
   }

   if (counter.testAlerts) {
      return {
         title: translationKeys.sosTestAlarm,
         description: translationKeys.sosAlarmHasBeenCalled,
         variant: 'error',
      };
   }

   return {
      title: translationKeys.sosAlarmDismissed,
      description: translationKeys.sosAlarmDismissedByReporter,
      variant: 'informative',
   };
};
